import React from 'react';
import { makeStyles, Typography, Link } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  navSectionHeading: {
    color: '#9E9E9E',
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    paddingTop: '1rem',
    lineHeight: '40px'
  },
  navSideBarLink: {
    lineHeight: '40px',
    cursor: 'pointer',
    display: 'block',
    color: '#ffffff',
    '&:hover': {
      color: '#ffffff'
    },
    '& :active': {
      color: '#ffffff'
    }
  }
}));

export const NavLinkSection = props => {
  const { linkSectionHeading, linkList } = props;
  const { navSectionHeading, navSideBarLink } = useStyles();

  const linkListBuilder = links => {
    return links.map(link => {
      const { linkText, clickAction } = link;
      return (
        <Link variant="body1" key={linkText} id={`navLink-${linkText.replace(/\s/g, '-')}`} className={navSideBarLink} onClick={clickAction}>
          {linkText}
        </Link>
      );
    });
  };

  return (
    <>
      {linkSectionHeading && (
        <Typography variant="body1" id={`navSection-${linkSectionHeading.replace(/\s/g, '-')}`} className={navSectionHeading}>
          {linkSectionHeading}
        </Typography>
      )}
      {linkList && linkListBuilder(linkList)}
    </>
  );
};
